import React, {useContext, useEffect, useRef} from 'react';
import { MyContext } from '../context/my_context';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/header.css';
import logoAlcaldia from "../assets/images/logos/logo-sin-letras.png";
import logoSivep from "../assets/images/logos/Logo_SIVEP.jpg";
import homeIcon from "../assets/images/icons/home-icon.jpeg";

const Header: React.FC = () => {
    const context = useContext(MyContext);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [menuOpen, setMenuOpen] = React.useState(false);

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    const handleClickOutside = (event: any) => {
        if (
            dropdownRef.current && !dropdownRef.current.contains(event.target) &&
            buttonRef.current && !buttonRef.current.contains(event.target)
        ) {
            setMenuOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    if (context === undefined) {
        throw new Error('Header must be used within a MyProvider');
    }

    const navigate = useNavigate();
    const { isAuthenticated, setIsAuthenticated } = context;

    const handleClick00 = () => {
        setMenuOpen(false);
        navigate('/home');
    };

    const handleClick01 = () => {
        setMenuOpen(false);
        navigate('/user_profile');
    };

    const handleClick02 = () => {
        setMenuOpen(false);
        navigate('/finger_print');
    };

    const handleClick03 = () => {
        setMenuOpen(false);
        navigate('/help_support');
    };

    const handleClick04 = () => {
        setMenuOpen(false);
        navigate('/seller_profile');
    };

    const handleClick05 = () => {
        setMenuOpen(false);
        navigate('/qr_reader_view');
    };

    const handleClick06 = () => {
        setMenuOpen(false);
        navigate('/search_seller_by_document');
    };

    const handleLogout = () => {
        // Remove authentication data from local storage
        localStorage.removeItem('authToken');
        localStorage.removeItem('authTimestamp');
        localStorage.removeItem('userData');

        // Update the authentication status
        setIsAuthenticated(false);

        // Redirects to the login page
        navigate('/');
    };

    if (!isAuthenticated) {
        // Do not render the Header if the user is not authenticated
        // If the user is not logged in, they should not see that Header with options that are not relevant
        return null;
    }

    return (
        <div className="header">
            <div className="header-buttons">
                <div className="dropdown" ref={dropdownRef}>
                    <ul className={`nav-list ${menuOpen ? 'open' : ''}`}>
                        <li><button onClick={handleClick00}>Menú principal</button></li>
                        <li><button onClick={handleClick05}>Leer código QR del Modulo</button></li>
                        <li><button onClick={handleClick06}>Buscar Ventero por documento</button></li>
                        <li><button onClick={handleClick04}>Perfil del Ventero</button></li>
                        <li><button onClick={handleClick01}>Perfil del Usuario</button></li>
                        <li><button onClick={handleClick03}>Soporte</button></li>
                        <li><button onClick={handleLogout}>Logout</button></li>
                    </ul>
                </div>
            </div>
            <div className="header-container">
                <img src={logoAlcaldia} alt="Logo" className="login-logo-header"/>
                <hr className="divider-header"/>
                <div className="sivep-container">
                    <img src={logoSivep} alt="Logo SIVEP" className="login-logo-sivep-header"/>
                </div>
            </div>
            <button ref={buttonRef} className="menu-icon" onClick={toggleMenu} aria-label={menuOpen ? "Cerrar menú" : "Abrir menú"}>
                {menuOpen ? (
                    <i className="fas fa-times"></i>
                ) : (
                    <img src={homeIcon} alt="Lock icon" className="fas fa-home"/>
                )}
            </button>
        </div>
    );
};

export default Header;

